import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=0b0d5b5a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=0b0d5b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d5b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0d5b5a')) {
      api.createRecord('0b0d5b5a', component.options)
    } else {
      api.reload('0b0d5b5a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=0b0d5b5a&scoped=true&", function () {
      api.rerender('0b0d5b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mQHwZCKPj5nm/JS/comp/DateRangeExt.vue"
export default component.exports